import React from "react";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";

/** T9: shown at every point that starts a Stripe Checkout. The acceptance row
 *  is written server-side when the session is created. Shared since PLANES,
 *  because the out-of-quotes card became a third place that starts one. */
export default function RefundNotice({ testId }) {
  return (
    <p className="text-[11px] text-smoke text-center" data-testid={testId}>
      <Trans
        i18nKey="billingX.refundNotice"
        components={{
          refund: <Link to="/refund-policy" target="_blank" rel="noopener noreferrer" className="underline hover:text-worker" />,
        }}
      />
    </p>
  );
}
